import React, { useState, useEffect, useRef } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";

import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../Base/Services/ToastService";
import Loader from "../../../../Base/Components/Loader/Loader";

import { getEstadosCategory } from "../../../../API/Global/Status/StatusRequests";
import { EditarTipoMantenimiento, GuardarTipoMantenimiento, getTipoTrabajo } from "../../../../API/Mantenimiento/MantenimientoRequest";

const TipoMantenimientoCRUD = ({
  showDialog,
  selected,
  setShowDialog,
  getInfo,
  modo,
}) => {
  const toast = useRef(null);

  const [estados, setEstados] = useState([{}]);
  const [tipoMantenimiento, setTipoMantenimiento] = useState([]);
  const [loading, setLoading] = useState(false);

  const initialValues = {
    IdTipoMantenimiento: -1,
    TipoMantenimiento: "",
    Descripcion: "",
    IdEstado: selected ? selected?.IdEstado  : 5,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
    const estadosTempo = await getEstadosCategory("General");
    setEstados(estadosTempo);

    const b = await getTipoTrabajo();
    setTipoMantenimiento(b);

    const estadoInicial = modo === "Crear" ? estadosTempo[0] : estadosTempo.find((e) => e.IdStatus === selected?.IdEstado);

    setValues({
      ...selected,
      Estado: estadoInicial, 
      IdEstado: estadoInicial?.IdEstado, 
    });
    setLoading(false);
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.TipoMantenimiento) {
      error.TipoMantenimiento = true;
      error.error = true;
    }
    if (!values.Estado || !values.Estado.IdStatus) {
      error.IdEstado = true;
      error.error = true;
    }
    setError(error);
    // console.log(error);
    return error;
  };

  const agregarTipoParo = async () => {
    const e = verificarInfo();
    if (!e.error) {
      const existingTipoParo = tipoMantenimiento.find((cur) => cur.TipoTrabajo === values?.TipoTrabajo);

      if (existingTipoParo &&(modo === "Crear" || existingTipoParo.IdTipoMantenimiento !== values.IdTipoMantenimiento)) {
        toastShow( toast, "error", "Error", "Ya existe un Tipo Mantenimiento con ese nombre" );
      } else {

        const Datos = {
          IdTipoMantenimiento: values?.IdTipoMantenimiento,
          TipoMantenimiento: values?.TipoMantenimiento,
          Descripcion: values?.Descripcion,
          IdEstado: values?.Estado.IdStatus,
        };
        if(Datos.IdTipoMantenimiento > 0){
          setLoading(true)
          const resultado = await EditarTipoMantenimiento(Datos);
          if(resultado[0]?.ESTADO === 1){
            toastShow( toast, "success", "Datos Editados", resultado[0]?.MENSAJE );
            getInfo()
            setTimeout(() => {
              onHide();
              setLoading(false)
            }, 1300);
          }else{
            toastShow( toast, "error", "Error al Editar", resultado[0]?.MENSAJE );
          }
        }else{
          const resultado = await GuardarTipoMantenimiento(Datos);
          if(resultado[0]?.ESTADO === 1){
            toastShow( toast, "success", "Datos Agregados", resultado[0]?.MENSAJE );
            getInfo()
            setTimeout(() => {
                onHide();
                setLoading(false)
            }, 1300);
          }else{
            toastShow( toast, "error", "Error al agregar", resultado[0]?.MENSAJE );
          }
        }
      }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Modificar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          if (modo === "Crear") {
            agregarTipoParo();
          } else {
            agregarTipoParo();
          }
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  const dialogTitle = modo === "Crear" ? "Agregar Tipo Mantenimiento" : "Modificar Tipo Mantenimiento";

  return (
    <div>
      <Dialog
        visible={showDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
        header={dialogTitle}
      >
      <Toast ref={toast}/>
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100", margin: "auto" }}>

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="TipoMantenimiento"
                    value={values.TipoMantenimiento}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.TipoMantenimiento ? "p-invalid" : ""}
                  />
                  <label htmlFor="TipoMantenimiento">Tipo Paro</label>
                </span>
              </div>

              <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                  <InputText
                    name="Descripcion"
                    value={values.Descripcion}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Descripcion ? "p-invalid" : ""}
                  />
                  <label htmlFor="Descripcion">Descripción</label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2  mt-2">
              <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Estado"}
                    value={values.Estado}
                    items={estados}
                    field={"StatusName"}
                    label={"Estado"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdEstado ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default TipoMantenimientoCRUD;
